export default "__VITE_ASSET__ACjPXqpF__"